// Resolve the filesystem root for a code session (agent tools, tests, E5 sync).
// Worktree sessions store the path in worktree_path; legacy rows may use directory.

export function sessionRoot(session) {
  return (session?.worktree_path || session?.directory || '').trim();
}
